export const DEFAULT_CLASSES =
  'flexbox-inline flexbox-centered padding-horizontal-8 font-family-system no-selection no-break-word no-outline overflow-hidden'

export const labelVariantsClasses = {
  primary: {
    default: 'blue-10 background-alpha-blue-45 border-small border-transparent',
    isDisabled: 'background-alpha-shade-55 shade-30',
    clickable: '',
  },
  secondary: {
    default: 'background-alpha-shade-55 shade-20 border-small border-shade-45',
    isDisabled: 'background-alpha-shade-55 shade-30',
    clickable: '',
  },
  tertiary: {
    default: 'background-transparent border-small border-shade-45 shade-20',
    isDisabled: 'background-alpha-shade-55 shade-30',
    clickable: 'background-shade-50-on-hover',
  },
  warn: {
    default:
      'background-warning warning-content border-small border-transparent',
    isDisabled: 'background-alpha-shade-55 shade-30',
    clickable: '',
  },
  success: {
    default:
      'background-success success-content border-small border-transparent',
    isDisabled: 'background-alpha-shade-55 shade-30',
    clickable: '',
  },
  destructive: {
    default: 'background-error error-content border-small border-none',
    isDisabled: 'background-alpha-shade-55 shade-30',
    clickable: '',
  },
  danger: {
    default: 'background-danger danger-content border-small border-transparent',
    isDisabled: 'background-alpha-shade-55 shade-30',
    clickable: '',
  },
  purple: {
    default:
      'purple-20 background-alpha-purple-50 border-small border-transparent',
    isDisabled: 'background-alpha-shade-55 shade-30',
    clickable: '',
  },
  custom: {
    default: 'border-small border-transparent',
    isDisabled: 'background-alpha-shade-55 shade-30',
    clickable: '',
  },
} as const

export const labelSizesStyles = {
  smaller: { height: 15, borderRadius: 9 },
  small: { height: 18, borderRadius: 9 },
  regular: { height: 24, borderRadius: 12 },
  medium: { height: 26, borderRadius: 14 },
} as const

export const labelSizesClassNames = {
  smaller: 'line-height-smaller',
  small: 'line-height-smaller',
  regular: 'line-height-large',
  medium: 'line-height-large',
} as const
